export default __webpack_public_path__ + "static/meshmap-cluster1-aa93c5ce5b36cbf174c2b55a7bd2d323.webp";